import React, { useEffect, useState } from 'react';
import { restAPI } from '../../Services/api';
import CustomSelect from '../../Components/Selects/CustomSelect';

export default function CountrySelect({defaultValue, label, name, text_error, type}) {
    
    const [data,setData] = useState([]);

    const [studyData, setStudyData] = useState([]); 

    // Run Just one time & fill component with country names
    useEffect(() => {
        restAPI.gets().getCountriesNames().then(response => {

            // console.log('countries: ', response.data.countries);

            var worldZones = ['WestEurope', 'SouthEurope', 'NorthEurope', 'EastEurope', 'CentralEurope', 'Multiple'];

            var auxFullCountryData = [];

            for(let i = 0 ; i < worldZones.length ; i++){

                auxFullCountryData.push(worldZones[i]);
            }

            auxFullCountryData.push(...response.data.countries);

            auxFullCountryData.sort();


            // console.log('auxFullCountryData: ', auxFullCountryData);


            setData(auxFullCountryData);


            /**only study***********/
            var auxStudyData = [];

            auxStudyData.push('Select');
            auxStudyData.push(...response.data.countries);
            auxStudyData.sort();
            setStudyData(auxStudyData);
            /********************************************/

        }).catch(error => {

        });
    }, [])

    return (

        <>
            {

            type === 'study' ? (
                
                <CustomSelect
                    label={label || "Food Origin"}
                    defaultValue={defaultValue}
                    name={name || "FoodOrigin"}
                    items={studyData}
                    labelError={text_error || ""}
                    clearable={true}
                />


            ):(

                <CustomSelect
                    label={label || "Food Origin"}
                    defaultValue={defaultValue}
                    name={name || "FoodOrigin"}
                    items={data}
                    labelError={text_error || ""}
                    clearable={true}
                />


            )

            }
        </>
        
    );
}